import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

/** 个人信息代码加载时保留四行资料和修改入口的位置，不提前读取资料或挂载编辑弹窗 */
export function AccountInfoSkeleton() {
  return (
    <div className="w-full h-full" aria-hidden="true">
      <div className="mb-2">
        <Skeleton className="h-7 w-20" />
      </div>
      {/** 昵称、邮箱、密码和手机号，沿用原资料区宽度及行间距 */}
      <div className="space-y-4 py-4 text-sm">
        {['w-28', 'w-48', 'w-16', 'w-28'].map((valueWidth, index) => (
          <div key={index} className="flex items-center justify-between max-w-115">
            <div className="w-95 flex flex-row items-center">
              <div className="w-20 shrink-0">
                <Skeleton className={cn('h-3.5', index === 3 ? 'w-10' : 'w-7')} />
              </div>
              <Skeleton className={cn('h-5', valueWidth)} />
            </div>
            {/** 修改入口仅展示占位，不提供可操作控件 */}
            <Skeleton className={cn('h-5 shrink-0', index === 3 ? 'w-[70px]' : 'w-14')} />
          </div>
        ))}
      </div>
    </div>
  );
}
